import type { BillingProfileDomainQueryModel } from '@mntn-dev/domain-types'

import { billingProfileHasAms } from './billing-profile-has-ams.ts'
import { billingProfileHasCreditCard } from './billing-profile-has-credit-card.ts'
import { billingProfileHasInvoicing } from './billing-profile-has-invoicing.ts'

export function billingProfileHasMoneyPaymentMethod(
  billingProfile: BillingProfileDomainQueryModel
) {
  return (
    billingProfileHasAms(billingProfile) ||
    billingProfileHasInvoicing(billingProfile) ||
    billingProfileHasCreditCard(billingProfile)
  )
}
